import { MetricGroupedCategories } from '@features/deals/types';

// Wizard steps
export const WIZARD_STEPS = [
  'Hotel Selection',
  'Financial Data',
  'Review & Analyze',
  'AI Valuation Insights',
  'Save Deal'
];

// Metric categories and grouping
export const METRIC_GROUPED_CATEGORIES: MetricGroupedCategories = {
  Revenue: {
    order: 1,
    items: [
      'Room Revenue',
      'F&B Revenue',
      'Other Revenue',
      'Total Revenue'
    ],
  },
  Expenses: {
    order: 2,
    items: [
      'Administrative & General',
      'Sales & Marketing',
      'Property Operations & Maintenance',
      'Utilities',
      'Room Expenses',
      'F&B Expenses',
      'Total Expenses'
    ],
  },
  'Performance Metrics': {
    order: 3,
    items: [
      'RevPAR',
      'ADR',
      'Occupancy Rate',
      'GOP',
      'NOI',
      'EBITDA'
    ],
  },
  Other: {
    order: 4,
    items: [
      'Cap Rate',
      'Price per Key',
      'Market Penetration Index'
    ],
  },
};

// Default hotel values
export const DEFAULT_HOTEL_INFO = {
  name: '',
  address: '',
  city: '',
  state: '',
  zip_code: '',
  country: 'USA',
  star_rating: 0,
  num_rooms: 0,
  year_built: 0,
  lot_size: 0,
  description: '',
  website: '',
  notes: '',
  amenities: [],
};

// Financial data
export const CURRENT_YEAR = new Date().getFullYear();

// API request constants
export const MAX_RETRIES = 3;
export const RETRY_DELAY = 2000; // ms